import React from 'react'
import Link, { withPrefix } from 'gatsby-link'
import Helmet from 'react-helmet'
import 'babel-polyfill'
import HomeTextCollapse from '../components/HomeTextCollapse/HomeTextCollapse'

//  Components
import HomeIntro from '../components/HomeIntro/HomeIntro'
import PageHeader from '../components/PageHeader/PageHeader'
import ThemeLink from '../components/ThemeLink/ThemeLink'
import KeyThemes from '../components/KeyThemes/KeyThemes'
import Button from '../components/Button/Button'
import Downloads from '../components/Downloads/Downloads'
import TopBottom from '../components/Visualizations/containers/top-bottom'

const TEXT_COLLAPSE_OPTIONS = {
  collapse: true, // default state when component rendered
  collapseText: 'Keep Reading', // text to show when collapsed
  expandText: 'View Less', // text to show when expanded
  minHeight: 0, // component height when closed
  maxHeight: 500, // expanded to
  textStyle: { // pass the css for the collapseText and expandText here
    color: '#f47920',
    fontSize: '20px',
  },
}

const IndexPage = ({ data }) => (
  <div>
    <HomeIntro data={data}/>
    <div
      className="section section__full section__pull_top section__exhibit section__exhibit__padded">
      <h2 className="title__block">The Top &amp; Bottom</h2>
      <TopBottom/>
      <div className="section__centered">
        <Button
          to="/rankings"
          text="Check Out All States"
        />
      </div>
    </div>
    <div className="section">
      <div className="section__row section__row__2_up">
        <div className="section__content section__content__narrow">
          <h3>The COVID-19 pandemic has disrupted health care around the globe. In the United
            States, where it has claimed the lives of more than 185,000 people, health systems in every state
            have been stretched — in some cases severely.</h3>
        </div>
        <div className="section__content section__content__wide">
          <p>
            The novel coronavirus has exposed and exacerbated existing weaknesses that have long been the focus of the <em>Commonwealth Fund’s Scorecard on State Health System Performance</em>. First, because most Americans get their health insurance through an employer, recent job losses have widened coverage gaps that existed prior to the crisis. The Urban Institute projects that 10 million people will lose their employer coverage by year’s end, leaving 3.5 million uninsured.<sup className="note__link"><a href="#1">1</a></sup> The loss of job-based coverage has also brought into sharp relief the impact of states’ decisions not to expand Medicaid eligibility for low-income residents; 12 states have yet to expand their programs as allowed under the Affordable Care Act (ACA).<sup className="note__link"><a href="#2">2</a></sup>
          </p>
          <HomeTextCollapse options={TEXT_COLLAPSE_OPTIONS}>
            <p>
              Second, Black, Latino, and other communities of color, already more likely to be
              uninsured, have been disproportionally burdened by COVID-19 and the related economic
              fallout. Systemic racial and ethnic inequities in health care access and quality have
              contributed to higher hospitalization and mortality rates from COVID-19 among Black,
              Latino, American Indian, and Alaska Native individuals, among others.
            </p>
            <p>
              Third, the pandemic has exposed the vulnerability of health providers reliant on the
              fee-for-service payment system. Many are facing steep revenue losses and the threat of
              closure as social-distancing restrictions, fear, and a nose-diving economy have driven
              down both the supply and demand for routine and elective care.<sup className="note__link"><a href="#3">3</a></sup>
            </p>
            <p>
              Finally, the country faces many unanswered questions on the extent to which COVID-19
              and the ongoing economic fallout will contribute to suicides, deaths from alcohol and
              substance use, and further erosion of Americans’ life expectancy.</p>
          </HomeTextCollapse>
        </div>
      </div>
    </div>
    <KeyThemes data={data}/>
    <Downloads/>
    <div className="section section__notes">
      <div className="section__row">
        <div className="section__content">
          <ol start="1" style={{ counterReset: 'item 0' }} className="list__notes">
            <li id="1">Jessica Banthin et al., <a
              href="https://www.urban.org/research/publication/changes-health-insurance-coverage-due-covid-19-recession"><span><em>Changes in Health Insurance Coverage Due to the COVID-19 Recession: Preliminary Estimates Using Microsimulation</em></span></a> (Urban Institute, July 2020).
            </li>
            <li id="2">Voters in Oklahoma and Missouri passed Medicaid expansion by ballot in June and August of 2020; the states are expected to implement expansion by the summer of 2021.
            </li>
            <li id="3">Ateev Mehrotra et al., <a href="https://www.commonwealthfund.org/publications/2020/aug/impact-covid-19-pandemic-outpatient-visits-changing-patterns-care-newest"><span><em>The Impact of the COVID-19 Pandemic on Outpatient Visits: Changing Patterns of Care in the Newest COVID-19 Hot Spots</em></span></a> (Commonwealth Fund, Aug. 2020).
            </li>
          </ol>
        </div>
      </div>
    </div>
  </div>
)

export default IndexPage

export const query = graphql`
    query SiteQuery {
        site {
            pathPrefix
            siteMetadata {
                title
                year
                subtitle
            }
        }
        allThemesJson {
            edges {
                node {
                    theme_id
                    title
                    path
                    stat {
                        suffix
                        number
                        text
                    }
                }
            }
        }
        allStatesJson {
            edges {
                node {
                    id
                    title
                    url
                }
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/pages/index.js